export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE
export const TROPICALIZED = LOCALE === 'es-AR' || LOCALE === 'es-PY'
const STORE = {
  DEV: {
    'es-CO': {
      card: 458,
      stickers: 459,
      wallpapers: 460,
    },
    'es-AR': {
      card: 465,
      stickers: 466,
      wallpapers: 467,
    },
    'es-PY': {
      card: 471,
      stickers: 472,
      wallpapers: 473,
    },
    'es-EC': {
      card: 462,
      stickers: 463,
      wallpapers: 464,
    },
    'es-PE': {
      card: 468,
      stickers: 469,
      wallpapers: 470,
    },
    'es-BO': {
      card: 474,
      stickers: 475,
      wallpapers: 476,
    },
    'es-CL': {
      card: 477,
      stickers: 478,
      wallpapers: 479,
    },
    'es-PR': {
      card: 480,
      stickers: 481,
      wallpapers: 482,
    },
    'es-DO': {
      card: 483,
      stickers: 484,
      wallpapers: 485,
    },
  },
  PDN: {
    'es-CO': {
      card: 514,
      stickers: 515,
      wallpapers: 516,
    },
    'es-EC': {
      card: 517,
      stickers: 518,
      wallpapers: 519,
    },
    'es-PE': {
      card: 520,
      stickers: 521,
      wallpapers: 522,
    },
    'es-AR': {
      card: 524,
      stickers: 525,
      wallpapers: 526,
    },
    'es-PY': {
      card: 527,
      stickers: 528,
      wallpapers: 529,
    },
    'es-CL': {
      card: 530,
      stickers: 531,
      wallpapers: 532,
    },
    'es-DO': {
      card: 533,
      stickers: 534,
      wallpapers: 535,
    },
    'es-PR': {
      card: 536,
      stickers: 537,
      wallpapers: 538,
    },
    'es-BO': {
      card: 540,
      stickers: 541,
      wallpapers: 542,
    },
  },
}

export const activities = STORE[ENV][LOCALE] || {
  card: 0,
  stickers: 0,
  wallpapers: 0,
}
function isFreeToday() {
  let d = new Date()
  return d.getDate() === 23 && d.getMonth() === 11 && d.getFullYear() === 2022
}
const costByCountry = {
  free: {
    card: 0,
    stickers: 0,
    wallpapers: 0,
  },
  'es-CO': {
    card: 5,
    stickers: 10,
    wallpapers: 10,
  },
  'es-BO': {
    card: 0,
    stickers: 0,
    wallpapers: 0,
  },
}
const datesByCountry = {
  'es-CO': ['09 de diciembre del 2022', '29 de diciembre del 2022'],
  'es-PE': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
  'es-AR': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
  'es-PY': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
  'es-CL': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
  'es-DO': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
  'es-PR': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
  'es-BO': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
  'es-EC': ['12 de diciembre del 2022', '29 de diciembre del 2022'],
}
const stickersByCountery = {
  'es-CO': 'https://sticker.ly/s/8JZ15U',
}

export const costActivity = isFreeToday()
  ? costByCountry['free']
  : costByCountry[LOCALE] || costByCountry['es-CO']

export const activity_stickers_link =
  stickersByCountery[LOCALE] || stickersByCountery['es-CO']

export const activity_dates = datesByCountry[LOCALE] || datesByCountry['es-CO']
